export default (routes) => {
    return {
        fire(func, funcname, args) {
            funcname = (funcname === undefined) ? 'init' : funcname;

            if (func !== '' && routes[func] && typeof routes[func][funcname] === 'function') {
                routes[func][funcname](args);
            }
        },
        load() {
            const bodyId = document.body.id
            let Router   = this
                        
            // Run common first
            Router.fire('common')
            // Run pages after
            Router.fire(bodyId)
            // Run common finalize after
            Router.fire('common', 'finalize')
        }
    }
}